import { createAction } from '@reduxjs/toolkit';

import type { CreateFunctionPayload } from '@polyai/stream/commands/handlers/functions/create-function/schema';
import type { DeleteFunctionPayload } from '@polyai/stream/commands/handlers/functions/delete-function/schema';
import type { UpdateFunctionPayload } from '@polyai/stream/commands/handlers/functions/update-function/schema';
import type { UpdateLatencyControlPayload } from '@polyai/stream/commands/handlers/functions/update-latency-control/schema';

const updateFunction = createAction<UpdateFunctionPayload>(
  `functions/updateFunction`,
);

const deleteFunction = createAction<DeleteFunctionPayload>(
  `functions/deleteFunction`,
);

const createFunction = createAction<CreateFunctionPayload>(
  `functions/createFunction`,
);

const updateLatencyControl = createAction<UpdateLatencyControlPayload>(
  `functions/updateLatencyControl`,
);

export { createFunction, deleteFunction, updateFunction, updateLatencyControl };
